import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loading': false,
  'filterText': '',
  'warehouseDenialCauseData': {},
  'list': [],
  'filteredList': [],
};

const FORM_INITIAL_STATE = {
  'loading': false,
  'modificationDate': '',
  'values': {
    'name': '',
    'moveToTMP': false,
    'status': true,
  },
};

const filterWarehouseDenialCauses = (list, value) => {
  return list.filter((element) => {
    const moveToTMP = element.moveToTMP ? 'SI' : 'NO';
    const status = element.status ? 'Activo' : 'Inactivo';
    return (
      [
        element.name || '',
        moveToTMP,
        status,
      ].some((text) =>
        text.toLowerCase().includes(value.toLowerCase()) || value === ''
      )
    );
  });
};

export const warehouseDenialCauses = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_WAREHOUSE_DENIAL_CAUSES_LIST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_WAREHOUSE_DENIAL_CAUSES_LIST]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
      'filteredList': action.response.data,
    }),
    [ActionTypes.FETCHED_WAREHOUSE_DENIAL_CAUSES_LIST_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
      'filteredList': [],
    }),
    [ActionTypes.CHANGE_WAREHOUSE_DENIAL_CAUSES_TEXT_FILTER]: (state, action) => ({
      ...state,
      'filterText': action.payload,
    }),
    [ActionTypes.FILTER_WAREHOUSE_DENIAL_CAUSES]: (state, action) => ({
      ...state,
      'filteredList': filterWarehouseDenialCauses(state.list, action.payload),
    }),
  })(state, action);
};

export const warehouseDenialCause = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_WAREHOUSE_DENIAL_CAUSE]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_WAREHOUSE_DENIAL_CAUSE]: (state, action) => ({
      ...state,
      'loading': false,
      'warehouseDenialCauseData': action.response.data,
    }),
    [ActionTypes.FETCHED_WAREHOUSE_DENIAL_CAUSE_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'warehouseDenialCauseData': {},
    }),
  })(state, action);
};

export const warehouseDenialCauseForm = (state, action) => {
  return createReducer(FORM_INITIAL_STATE, {
    [ActionTypes.FETCHING_WAREHOUSE_DENIAL_CAUSE]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_WAREHOUSE_DENIAL_CAUSE]: (state, action) => ({
      ...state,
      'loading': false,
      'modificationDate': action.response.data.modificationDate,
      'values': {
        'name': action.response.data.name,
        'moveToTMP': action.response.data.moveToTMP,
        'status': action.response.data.status,
      },
    }),
    [ActionTypes.FETCHED_WAREHOUSE_DENIAL_CAUSE_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'modificationDate': '',
      'values': {
        'name': '',
        'moveToTMP': false,
        'status': true,
      },
    }),
  })(state, action);
};
